<template>
    <div class="ebook" :style="{background: themeList[defaultTheme].style.body.background}">
        <!-- <TitleBar :ifTitleAndMenuShow="ifTitleAndMenuShow"></TitleBar> -->

        <div class="read-wrapper">
            <!-- <div class="position_rightLeftBtn" hidden> -->
            <div class="position_rightLeftBtn position_LeftBtn" @click="prevPage">
                <img src="@/assets/epub/quanjuleft.png" alt>
            </div>
            <div class="position_rightLeftBtn position_RightBtn" @click="nextPage">
                <img src="@/assets/epub/quanjuright.png" alt>
            </div>
            <!-- </div>  -->
            <VueDragResize
                :x="DragResize.x"
                :y="DragResize.y"
                :w="DragResize.w"
                :h="DragResize.h"
                :is-active="true"
                :is-resizable="false"
                style="outline: none!important;border: none!important;"
            >
                <div id="read">
                  <el-carousel
                      ref="carousel"
                      height="500px"
                      :style="{width:'980px',transform:`scale(${bookscale})`}"
                      :autoplay="false"
                      :loop="false"
                      v-if="!isPx"
                  >
                    <el-carousel-item v-for="(item,index) in page.pagecount" :key="item">
                      <!-- {{index*2-1}}{{index*2}} -->
                      <!-- {{page.page*2}}{{page.page*2+1}} -->
                      <div v-if="index==0" class="dataimgWarp">
                        <ul>
                          <li v-for="(item,index) in datalist[0]" :key="index">
                            <img :src="item" alt>
                          </li>
                        </ul>
                      </div>
                      <div
                          v-if="index!=0"
                          class="dataimgWarp"
                          style="width:2048px;transform: scale(0.37) translate(-70%,-84.5%);"
                      >
                        <ul style="width:1024px">
                          <li v-for="(item,index) in datalist[index*2-1]" :key="index">
                            <img :src="item" alt>
                          </li>
                        </ul>
                        <ul style="width:1024px;margin-left: -4.5px;">
                          <li v-for="(item,index) in datalist[index*2]" :key="index">
                            <img :src="item" alt>
                          </li>
                        </ul>
                      </div>
                    </el-carousel-item>
                  </el-carousel>

                  <el-carousel
                        ref="carousel"
                        height="800px"
                        :style="{width:'1600px',transform:`scale(${bookscale})`}"
                        :autoplay="false"
                        :loop="false"
                        v-if="isPx"
                    >
                        <el-carousel-item v-for="(item,index) in page.pagecount" :key="item">
                            <!-- {{index*2-1}}{{index*2}} -->
                            <!-- {{page.page*2}}{{page.page*2+1}} -->
                            <div v-if="index==0" class="dataimgWarp-big">
                                <ul>
                                    <li v-for="(item,index) in datalist[0]" :key="index">
                                        <img :src="item" alt>
                                    </li>
                                </ul>
                            </div>
                            <div
                                v-if="index!=0"
                                class="dataimgWarp-big"
                                style="width:10700px;transform: scale(0.3) translate(-142%,-110%);"
                            >
                                <ul style="width:1624px">
                                    <li v-for="(item,index) in datalist[index*2-1]" :key="index">
                                        <img :src="item" alt>
                                    </li>
                                </ul>
                                <ul style="width:1624px;margin-left: -4.5px;">
                                    <li v-for="(item,index) in datalist[index*2]" :key="index">
                                        <img :src="item" alt>
                                    </li>
                                </ul>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </VueDragResize>
        </div>
        <MenuBar
            :if-title-and-menu-show="ifTitleAndMenuShow"
            :font-size-list="fontSizeList"
            :default-font-size="defaultFontSize"
            :theme-list="themeList"
            :book-available="bookAvailable"
            :default-theme="defaultTheme"
            :navigation="navigation"
            :progressval="progressval"
            ref="menuBar"
            :menu-issue="menuIssue"
            :footerinput="`${page.page*2 == 0 ? '' : page.page*2 +'-'}${page.page*2+1}页 共${$route.query.pagecount}页`"
            :get-data-thumbnai-lists="getDataThumbnaiLists"
            @setFontSize="setFontSize"
            @setTheme="setTheme"
            @onProgressChange="onProgressChange"
            @jumpTo="jumpTo"
            @setPagesize="setPagesize"
            @setMenuSub="setMenuSub"
            @goPageimg="goPageimg"
            @oniconWrInputSubmit="oniconWrInputSubmit"
        />
    </div>
</template>

<script>
// import TitleBar from './components/TitleBar'
    import {
        resourceGetOriginalImages,
        getOriginalThumbnailImages
    } from '@/api/lxc'
    import { oneJournalPageList } from '@/api/lyl'
    import VueDragResize from 'vue-drag-resize'
    import MenuBar from './components/MenuBar'

    export default {
        name: 'Ebook',
        components: {
            // TitleBar,
            MenuBar,
            VueDragResize
        },
        props: [''],
        data () {
            return {
                getDataThumbnaiLists: [],
                menuList: [],
                DragResize: {
                    x: (window.innerWidth - 980) / 2,
                    y: (window.innerHeight - 500) / 2,
                    w: 980,
                    h: 500
                },
                bookscale: 1.08,
                datalist: [],
                page: {
                    page: 0,
                    pagecount: 0
                },
                progressval: 0, //阅读进度
                ifTitleAndMenuShow: true,
                //字体列表
                fontSizeList: [
                    { fontSize: 12 },
                    { fontSize: 14 },
                    { fontSize: 16 },
                    { fontSize: 18 },
                    { fontSize: 20 },
                    { fontSize: 22 },
                    { fontSize: 24 }
                ],
                //默认颜色
                defaultFontSize: 14,
                //主题列表
                themeList: [
                    {
                        name: '背景一',
                        style: {
                            body: {
                                color: '#333333',
                                background: '#ffffff'
                            }
                        }
                    },
                    {
                        name: '背景二',
                        style: {
                            body: {
                                color: '#ffffff',
                                background: '#333333'
                            }
                        }
                    },
                    {
                        name: '背景三',
                        style: {
                            body: {
                                color: '#000000',
                                background: '#CDE8CE'
                            }
                        }
                    },
                    {
                        name: '背景四',
                        style: {
                            body: {
                                color: '#000000',
                                background: '#F5F2E9'
                            }
                        }
                    },
                    {
                        name: '背景五',
                        style: {
                            body: {
                                color: '#000000',
                                background: '#E6F7FF'
                            }
                        }
                    }
                ],
                defaultTheme: 0,
                //locations对象是否生成
                bookAvailable: false,
                navigation: {},
                isPx:false,
                elStyle:{
                  width:'1600px',
                  transform:`scale(${this.bookscale})`
                }
            }
        },

        computed: {
            webInfo () {
                return this.$store.state.webInfo
            },
            menuIssue () {
                return {
                    leng: this.menuList.length,
                    index: this.menuList.findIndex((item, index) => {
                        return Number(this.$route.query.issue) === Number(item.issue)
                    })
                }
            }
        },
        watch: {
            '$route.query': function () {
                this.page.pagecount = Math.round(
                    (Number(this.$route.query.pagecount) - 1) / 2 + 1
                )
                this.getDataList(this.page.page + 1)
                this.getDataList(this.page.page + 2)
                this.getDataList(this.page.page + 3)
                const params = {
                    oprate_type: '原貌阅读',
                    query_way: '站内',
                    module_name: '原貌阅读',
                    resource_type: this.$route.query.year ? '期刊' : '图书',
                    resource_id: this.$route.query.bookid,
                    year: this.$route.query.year,
                    issue: this.$route.query.issue,
                    resource_name: this.$route.query.bookname
                }
                if (this.$route.query.author) {
                    params.author = this.$route.query.author
                }
                this.$sta.staAdmin(params)
            }
        },

        beforeMount () {},

        mounted () {
            this.page.pagecount = Math.round(
                (Number(this.$route.query.pagecount) - 1) / 2 + 1
            )
            for (let i = 0; i < Number(this.$route.query.pagecount); i++) {
                this.datalist.push([])
            }
            console.log(this.datalist, '-datalist')
            this.getDataList(this.page.page + 1)
            this.getDataList(this.page.page + 2)
            this.getDataList(this.page.page + 3)
            if (this.$route.query.year) {
                this.getMenu()
            }
            this.getDataThumbnaiList()
            this.$sta.staAdmin({
                oprate_type: '浏览',
                query_way: '站内',
                module_name: '原貌阅读'
            })
            //阅读次数
            const params = {
                oprate_type: '原貌阅读',
                query_way: '站内',
                module_name: '原貌阅读',
                resource_type: this.$route.query.year ? '期刊' : '图书',
                resource_id: this.$route.query.bookid,
                year: this.$route.query.year,
                issue: this.$route.query.issue,
                resource_name: this.$route.query.bookname
            }
            if (this.$route.query.author) {
                params.author = this.$route.query.author
            }
            this.$sta.staAdmin(params)
            // service_code: this.webInfo.service_code,
        },

        methods: {
            async getMenu () {
                try {
                    const data = await oneJournalPageList({
                        service_code: this.webInfo.service_code,
                        id: this.$route.query.bookid,
                        year: this.$route.query.year,
                        page: 1,
                        pageSize: 100
                    })
                    this.menuList = data.records
                } catch (err) {
                    console.log(err)
                }
            },
            async getDataList (pageindex) {
                try {
                    const data = await resourceGetOriginalImages({
                        service_code: this.webInfo.service_code,
                        codename: this.$route.query.codename,
                        year: this.$route.query.year ? this.$route.query.year : '',
                        issue: this.$route.query.issue ? this.$route.query.issue : '',
                        pageNo: pageindex,
                        type: 1
                    })
                    let that = this
                    let imgUrl = data[0]
                    let img = new Image()
                    img.src = imgUrl
                    img.onload = function(){
                      if(img.width > 300){
                        that.isPx = true
                      }
                    }
                    this.$set(this.datalist, pageindex - 1, data)
                } catch (err) {
                    console.log(err)
                }
            },
            //getOriginalThumbnailImages
            async getDataThumbnaiList (pageindex) {
                try {
                    const data = await getOriginalThumbnailImages({
                        service_code: this.webInfo.service_code,
                        codename: this.$route.query.codename,
                        year: this.$route.query.year ? this.$route.query.year : '',
                        issue: this.$route.query.issue ? this.$route.query.issue : '',
                        startPage: '1',
                        endPage: '100',
                        type: this.$route.query.type
                    })
                    this.getDataThumbnaiLists = this.againGroup(data, 6)
                } catch (err) {
                    console.log(err)
                }
            },
            againGroup (data, num) {
                const result = []

                for (let i = 0, len = data.length; i < len; i += num) {
                    result.push(data.slice(i, i + num))
                }

                return result
            },
            setFontSize () {},
            jumpTo () {},
            setMenuSub (res) {
                this.datalist = []
                console.log(this.menuIssue, this.menuList)
                if (res == 7) {
                    //上一篇
                    this.$router.push({
                        query: {
                            codename: this.$route.query.codename,
                            year: this.$route.query.year,
                            pagecount: this.$route.query.pagecount,
                            bookid: this.$route.query.bookid,
                            issue: this.menuList[this.menuIssue.index - 1].issue,
                            bookname: this.$route.query.bookname
                        }
                    })
                } else {
                    this.$router.push({
                        query: {
                            codename: this.$route.query.codename,
                            year: this.$route.query.year,
                            pagecount: this.$route.query.pagecount,
                            bookid: this.$route.query.bookid,
                            issue: this.menuList[this.menuIssue.index + 1].issue,
                            bookname: this.$route.query.bookname
                        }
                    })
                }
                this.$router.go(0)
            },
            //输入框跳转
            oniconWrInputSubmit (res) {
                // this.webInfo.readStatus=2;
                if (this.webInfo.readStatus != 2 && this.page.page == 1) {
                    this.$message('您暂无阅读权限')
                    return false
                }
                this.page.page = Number(`${ ((Number(res)) / 2 + 1) }`.split('.')[0]) - 1
                this.setpage(9)
            },
            //缩略图跳转
            goPageimg (res) {
                // this.webInfo.readStatus=1;
                if (this.webInfo.readStatus != 2 && this.page.page == 1) {
                    this.$message('您暂无阅读权限')
                    return false
                }
                this.page.page = Number(`${ ((Number(res)) / 2 + 1) }`.split('.')[0]) - 1
                this.setpage(9)
            },
            setpage (res) {
                if (res == 7) {
                    //上一页
                    if (this.page.page == 0) {
                        this.$message({
                            message: '已经是第一页啦',
                            center: true
                        })
                        return false
                    }
                    this.page.page = this.page.page - 1
                    console.log(this.page.page)
                    this.getLeftRightData()
                } else if (res == 9) {
                    if (this.page.page <= -1) {
                        return false
                    } if (this.page.page > this.$route.query.pagecount) {
                        return false
                    }
                    console.log(this.page.page, 2)
                    this.getLeftRightData()
                } else {
                    //下一页
                    if (this.page.page == this.page.pagecount - 1) {
                        this.$message({
                            message: '最后一页啦',
                            center: true
                        })
                        return false
                    }
                    // this.webInfo.readStatus=1;
                    if (this.webInfo.readStatus != 2 && this.page.page == 1) {
                        this.$message('您暂无阅读权限')
                        return false
                    }
                    this.page.page = this.page.page + 1
                    const rigntPage = this.page.page * 2 - 1
                    const leftPage = rigntPage - 1
                    this.getLeftRightData()
                    //预加载下一页
                    const nextLeftpage = leftPage + 4
                    const nextRightpage = rigntPage + 4
                    if (typeof this.datalist[nextLeftpage - 1] === 'object') {
                        if (!this.datalist[nextLeftpage - 1][0]) {
                            this.getDataList(nextLeftpage)
                        }
                    }
                    if (typeof this.datalist[nextRightpage - 1] === 'object') {
                        if (!this.datalist[nextRightpage - 1][0]) {
                            this.getDataList(nextRightpage)
                        }
                    }
                }
                this.$refs.carousel.setActiveItem(this.page.page)
            },
            //获取当前页码 左右两页数据
            getLeftRightData () {
                const rigntPage = this.page.page * 2 - 1
                const leftPage = rigntPage - 1
                if (typeof this.datalist[leftPage + 2 - 1] === 'object') {
                    if (!this.datalist[leftPage + 2 - 1][0]) {
                        this.getDataList(leftPage + 2)
                    }
                }
                if (this.datalist[rigntPage + 2 - 1]) {
                    if (!this.datalist[rigntPage + 2 - 1][0]) {
                        this.getDataList(rigntPage + 2)
                    }
                }
            },
            toggleTitleAndMenuShow () {
                this.ifTitleAndMenuShow = !this.ifTitleAndMenuShow
            },
            //切换主题
            setTheme (index) {
                this.defaultTheme = index
            },
            //进度条变化 (0 -100 进度条变化)
            onProgressChange (progress) {
                if (progress == 0) {
                    this.bookscale = 1.08
                    return false
                }
                this.bookscale = 1.2 + progress / 100
            },
            setPagesize (val) {
                if (val === 1) {
                    //上一页
                    this.setpage(7)
                } else {
                    //下一页
                    this.setpage(8)
                }
            },
            //上一页
            prevPage () {
                this.setpage(7)
            },
            //下一页
            nextPage () {
                this.setpage(8)
            }
        }
    }
</script>

<style lang='less' scoped>
.dataimgWarp-big {
  transform: scale(0.3) translateY(-110%);
  width: 1600px;
  font-size: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    li {
      display: inline-block;
      font-size: 0;
      list-style: none;
      padding: 0;
      margin: -1.3px 0 0 -1.3px;
      img {
        width: auto;
        height: auto;
        display: block;
        vertical-align: bottom;
      }
    }
  }
}
.dataimgWarp {
  transform: scale(0.37) translateY(-84.5%);
  width: 1024px;
  font-size: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    li {
      display: inline-block;
      font-size: 0;
      list-style: none;
      padding: 0;
      margin: -1.3px 0 0 -1.3px;
      img {
        width: auto;
        height: auto;
        display: block;
        vertical-align: bottom;
      }
    }
  }
}

.ebook {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  #read {
    // background: red;
    position: absolute;
    left: 50%;
    top: 46%;
    cursor: move;
    transform: translate(-50%, -50%);
  }
  .read-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .position_rightLeftBtn {
    color: #ffffff;
    width: 48px;
    height: 48px;
    text-align: center;
    line-height: 30px;
    font-size: 20px;
    position: absolute;
    // font-weight: 600;
    z-index: 9;
    top: 40%;
    opacity: 0;
    cursor: pointer;
    transition: 0.2s;
    img {
      width: 48px;
    }
  }
  .position_rightLeftBtn:hover {
    transform: scale(1.1);
  }
  .position_LeftBtn {
    left: 5%;
    b {
      margin-left: -2px;
    }
  }
  .position_RightBtn {
    right: 5%;
    b {
      margin-right: -2px;
    }
  }
  .read-wrapper:hover .position_rightLeftBtn {
    opacity: 1;
  }
}
</style>
<style>
.ebook .el-carousel__indicators {
  display: none !important;
}
.ebook .el-carousel__arrow {
  display: none !important;
}
.vdr.active:before {
  outline: none !important;
}
.vdr.active {
  outline: none !important;
}
.vdr {
  outline: none !important;
}
.vdr,
.vdr.active:before {
  outline: none !important;
  border: none !important;
}
</style>
